import { render } from "./price-periods.vue?vue&type=template&id=417c629e"
import script from "./price-periods.vue?vue&type=script&lang=js"
export * from "./price-periods.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__